import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const generatePDF = async (entries, stats, speciesData) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();

  doc.setFontSize(24);
  doc.setTextColor(85, 98, 79);
  doc.text("Nature Journal Report", pageWidth / 2, 20, { align: "center" });

  doc.setFontSize(10);
  doc.setTextColor(124, 128, 104);
  doc.text(`Generated on ${new Date().toLocaleDateString()}`, pageWidth / 2, 28, { align: "center" });

  doc.setFontSize(16);
  doc.setTextColor(46, 51, 43);
  doc.text("Statistics Summary", 14, 45);

  doc.setFontSize(11);
  doc.setTextColor(85, 98, 79);
  const statsY = 55;
  doc.text(`Total Entries: ${entries.length}`, 14, statsY);
  doc.text(`Total Sightings: ${stats?.total_sightings || 0}`, 14, statsY + 7);
  doc.text(`Unique Species: ${stats?.unique_species || 0}`, 14, statsY + 14);
  doc.text(`Categories: ${stats?.categories?.length || 0}`, 14, statsY + 21);

  if (stats?.top_species?.length > 0) {
    doc.setFontSize(14);
    doc.setTextColor(46, 51, 43);
    doc.text("Top Species Identified", 14, statsY + 38);

    const speciesTableData = stats.top_species.slice(0, 5).map((sp, idx) => [
      idx + 1,
      sp.name,
      sp.count
    ]);

    autoTable(doc, {
      startY: statsY + 45,
      head: [["#", "Species", "Sightings"]],
      body: speciesTableData,
      theme: "striped",
      headStyles: { fillColor: [85, 98, 79] },
      margin: { left: 14 }
    });
  }

  let currentY = doc.lastAutoTable?.finalY + 20 || 130;

  if (currentY > 250) {
    doc.addPage();
    currentY = 20;
  }

  doc.setFontSize(16);
  doc.setTextColor(46, 51, 43);
  doc.text("Journal Entries", 14, currentY);

  const entriesTableData = entries.slice(0, 20).map(entry => [
    entry.title,
    entry.location || "-",
    new Date(entry.created_at).toLocaleDateString(),
    entry.tags?.join(", ") || "-"
  ]);

  autoTable(doc, {
    startY: currentY + 7,
    head: [["Title", "Location", "Date", "Tags"]],
    body: entriesTableData,
    theme: "striped",
    headStyles: { fillColor: [85, 98, 79] },
    margin: { left: 14 },
    columnStyles: {
      0: { cellWidth: 50 },
      1: { cellWidth: 40 },
      2: { cellWidth: 30 },
      3: { cellWidth: 60 }
    }
  });

  if (speciesData?.length > 0) {
    doc.addPage();
    doc.setFontSize(16);
    doc.setTextColor(46, 51, 43);
    doc.text("Species Gallery", 14, 20);

    const speciesGalleryData = speciesData.map(sp => [
      sp.species_name,
      sp.category,
      sp.total_count,
      sp.sightings[0]?.location || "-"
    ]);

    autoTable(doc, {
      startY: 27,
      head: [["Species", "Category", "Sightings", "First Location"]],
      body: speciesGalleryData,
      theme: "striped",
      headStyles: { fillColor: [194, 90, 60] },
      margin: { left: 14 }
    });
  }

  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setTextColor(124, 128, 104);
    doc.text(
      `Nature Journal - Page ${i} of ${pageCount}`,
      pageWidth / 2,
      doc.internal.pageSize.getHeight() - 10,
      { align: "center" }
    );
  }

  doc.save("nature-journal-report.pdf");
  return true;
};

export { generatePDF };
